import { z } from 'zod';

import { confirmationOfApplicationSchema } from '@/features/ui/Steps/ConfirmationOfApplication/model/schemas';

import {
  zodEmail,
  zodMobilePhoneUA,
  zodSelectOption,
  zodUkrainianName,
  zodStringRequired,
  savedAttachment,
  zodStringRequiredWithMinMax,
} from '@/shared/lib/validations';
import { ukrainianAddressSchema } from '@/shared/ui/AddressBlock/model';

export const personalDataSchema = z.object({
  lastName: zodUkrainianName(),
  firstName: zodUkrainianName(),
  middleName: zodUkrainianName().optional().or(z.literal('')),
  email: zodEmail,
  phone: zodMobilePhoneUA,
  category: z
    .object(
      {
        id: zodStringRequired,
        label: zodStringRequired,
        confirmation_required: z.boolean(),
      },
      { message: 'Необхідно заповнити поле' },
    )
    .nullish(),
  userCategory: savedAttachment.nullish(),
});

export const personalDataBlockSchema = personalDataSchema.superRefine((data, ctx) => {
  if (data.category?.confirmation_required === true) {
    if (!data.userCategory || data.userCategory.length === 0) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['userCategory'],
        message: 'Необхідно заповнити поле',
      });
    }
  }
});

export const residenceAddressSchema = z.object({
  residenceAddress: ukrainianAddressSchema,
});
export const residenceDescriptionOfRequestSchema = z.object({
  appealType: zodSelectOption,
  appealMessage: zodStringRequiredWithMinMax({ min: 100, max: 4000 }),
  appealAttachments: savedAttachment.nullish(),
});

export const citizenAppealServiceMergedSchema = personalDataSchema
  .merge(residenceAddressSchema)
  .merge(residenceDescriptionOfRequestSchema)
  .merge(confirmationOfApplicationSchema);
